import type { ReactNode } from "react";
import { Layout } from "react-admin";
import { AppMenu } from "./AppMenu";

export function AppLayout({ children }: { children: ReactNode }) {
  return <Layout menu={AppMenu}>{children}</Layout>;
}
